import Dashboard from './dashboard.component';

export default {
  Root: Dashboard,
};
